export const Device = {
  OsType: {
    ios: 1,
    android: 2,
    web: 3,
  },
};
